<sc-flex vertical fitHeight stretchContent>
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.attach-truck"></sc-dictionary-label>
  </sc-title>
  <sc-flex-fitting-content vertical>
    <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent [hideFilter]="true"
      (selectionChanged)="onSelectionChanged($event)">
    </sc-tmc-table>
  </sc-flex-fitting-content>
  <div [formGroup]="detailsFormGroup" *ngIf="serviceVehiclesEnabled">
    <sc-flex [centered]="true">
      <mat-checkbox name="useAsServiceTruck" formControlName="useAsServiceTruck">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.attach-truck.use-as-service-truck"></sc-dictionary-label>
      </mat-checkbox>
    </sc-flex>
  </div>
</sc-flex>
